import React, { useContext } from 'react';
import styles from './index.module.scss';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';
import { getImageFromS3 } from '../../../imageService';

const ROZETKA_LINK =
  'https://rozetka.com.ua/ua/sigareti/c4638591/producer=b84d5fce;tolshchina139079=kompakt-demi/?utm_source=PMU_sms_lm_rvmp';
const CIG_POSHTA_LINK =
  'https://cig-poshta.in.ua/shop/lm/swoof/fyltr-povitryanyj-filtr/?utm_source=cda_lm_rvmp';

const HomeScreen = () => {
  const { sendEvent } = useContext(DataLayerEventContext);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img
          className={styles.headBg}
          src={getImageFromS3('images/25-sms-lm-rvmp/head-bg.png')}
          alt="head-bg"
        />
        <img
          className={styles.formatBg}
          src={getImageFromS3('images/25-sms-lm-rvmp/format-bg.png')}
          alt="format-bg"
        />
        <div className={styles.headContainer}>
          <img
            className={styles.logo}
            src={getImageFromS3('images/25-sms-lm-rvmp/logo.png')}
            alt="logo"
          />
          <p className={styles.headTitle}>
            Незмінна якість
            <br />в оновленому дизайні*
          </p>
          <img
            className={styles.pack}
            src={getImageFromS3('images/25-sms-lm-rvmp/pack.png')}
            alt="pack"
          />
          <div className={styles.packLabels}>
            <p>
              Loft Blue
              <br />6 мг
            </p>
            <p>
              Loft Sea Blue
              <br />4 мг
            </p>
          </div>
          <div className={styles.disclaimer}>
            *Змінюється лише дизайн пачки. Характеристики сигарет (фільтр, тютюн
            <br />
            та формат) залишаються незмінними.
          </div>
        </div>
        <div className={styles.formatContainer}>
          <p className={styles.formatTitle}>
            «King Size Slims»
            <br />
            компактний формат
          </p>
          <div className={styles.characteristicsContainer}>
            <div>
              <img
                src={getImageFromS3('images/25-sms-lm-rvmp/filter.png')}
                alt="filter"
              />
              <p>
                <b>Recessed 2.0</b>
                <br />
                фільтр з повітряною камерою
              </p>
            </div>
            <div>
              <img
                src={getImageFromS3('images/25-sms-lm-rvmp/tobacco.png')}
                alt="tobacco"
              />
              <p>
                <b>Бленд з трьох </b>
                сортів тютюну
              </p>
            </div>
          </div>
          <img
            className={styles.packs}
            src={getImageFromS3('images/25-sms-lm-rvmp/packs.png')}
            alt="packs"
          />
        </div>
        <div className={styles.buyContainer}>
          <p className={styles.buyTitle}>Де купити?</p>
          <p className={styles.buyDescription}>
            Актуальний асортимент можна знайти у роздрібних точках продажу в
            твоєму місті або на офіційних онлайн сервісах, зокрема:
          </p>
          <div className={styles.buttonContainer}>
            <a
              href={ROZETKA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.buttonItem}
              onClick={() => sendEvent('rozetka')}
            >
              <p>Rozetka</p>
            </a>
            <a
              href={CIG_POSHTA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.buttonItem}
              onClick={() => sendEvent('cig-poshta')}
            >
              <p>Cig-Poshta</p>
            </a>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <div>
          <p>Куріння викликає серйозні захворювання та залежність</p>
          <p>Дана інформація про продукт надається відповідно</p>
          <p>до статті 15 Закону України «Про захист прав споживачів»</p>
        </div>
      </div>
      <div className={styles.unsubscribe}>
        <div>
          Ти отримав(-ла) повідомлення, оскільки залишав(-ла) запит на отримання
          інформації про продукцію компаній Philip Morris в Україні.{' '}
          <a href="/unsubscribe?returnLink=25-sms-lm-rvmp">
            Відписатися від SMS тут.
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;
